import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=2a28276e&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a28276e')) {
      api.createRecord('2a28276e', component.options)
    } else {
      api.reload('2a28276e', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=2a28276e&", function () {
      api.rerender('2a28276e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/mailbox/Message.vue"
export default component.exports